import React from "react"
import LocationInfo from "@geome/shell-locator-components/lib/components/locationInfo"
import Pane from "@geome/shell-locator-components/lib/components/pane"
import OpenNow from "@geome/shell-locator-components/lib/components/openNow"
import IconListContainer from "@geome/shell-locator-components/lib/containers/iconList"
import IconList from "@geome/shell-locator-components/lib/components/iconList"
import IconAssets from "@geome/shell-locator-icons"
import PropertiesListContainer from "@geome/shell-locator-components/lib/containers/propertiesList"
import PropertiesListView from "@geome/shell-locator-components/lib/components/propertiesList"
import OpeningHours from "@geome/shell-locator-components/lib/components/locationInfo/sections/openingHours"
import PropTypes from "prop-types"
import {
  Pin,
  Phone,
  Clock,
  Pump,
  Mug,
  Earth,
} from "@geome/shell-locator-components/lib/components/locationInfo/icons"
import openGoogleDirections from "../../util/openGoogleDirections"

class InfoWindowView extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      address: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      postcode: PropTypes.string.isRequired,
      website_url: PropTypes.string.isRequired,
      telephone: PropTypes.string,
      fuels: PropTypes.arrayOf(PropTypes.string),
      amenities: PropTypes.arrayOf(PropTypes.string),
      country_code: PropTypes.string.isRequired,
    }),
    translate: PropTypes.func.isRequired,
    enabledAmenities: PropTypes.arrayOf(PropTypes.string).isRequired,
    priorityAmenities: PropTypes.arrayOf(PropTypes.string).isRequired,
  }

  openingHoursSection() {
    const { location, translate } = this.props
    const section = {
      name: "opening-hours",
      icon: <Clock />,
      head: (
        <OpenNow
          nextOpenStatusChange={location.next_open_status_change}
          tzOffset={location.tz_offset}
          openStatus={location.open_status}
          translate={translate}
        />
      ),
    }
    if (location.open_status !== "twenty_four_hour") {
      section.body = <OpeningHours translate={translate} openingHours={location.opening_hours} />
    }
    return section
  }

  fuelSection() {
    const { translate, location } = this.props
    const fuels = location.fuels

    return {
      name: "fuel-available",
      icon: <Pump />,
      head: translate("info_window.fuel_prices.not_available"),
      body: (
        <div className="location-info__fuels">
          {(fuels || []).map((fuel) => (
            <div key={fuel}>{translate(`fuels.${fuel}`)}</div>
          ))}
        </div>
      ),
    }
  }

  amenitiesSection() {
    const { location, translate } = this.props

    return {
      name: "amenities",
      icon: <Mug />,
      head: (
        <div>
          {translate("info_window.services")}
          <IconListContainer propertyNames={["amenities"]} location={location} assets={IconAssets}>
            {(props) => <IconList {...props} className="u-w100% icon-list__info-window" />}
          </IconListContainer>
        </div>
      ),
      body: (
        <PropertiesListContainer propertyName="amenities" location={location}>
          {(props) => <PropertiesListView {...props} translationPrefix="amenities" />}
        </PropertiesListContainer>
      ),
    }
  }

  render() {
    const { location, translate } = this.props
    const { address, city, postcode, website_url, telephone } = location

    return (
      <Pane className="pane--cut-off-background-colour u-flex-grow-1 group-padding-x">
        <LocationInfo
          location={this.props.location}
          shouldShowDirectionsButton
          onDirectionsClick={openGoogleDirections}
          translate={translate}
          sections={[
            {
              name: "address",
              icon: <Pin />,
              head: [address, postcode, city].filter(Boolean).join(", "),
            },
            telephone && {
              name: "telephone",
              icon: <Phone />,
              head: (
                <a className="location-info__telephone" href={`tel:${telephone}`}>
                  {telephone}
                </a>
              ),
            },
            {
              name: "website",
              icon: <Earth />,
              head: (
                <a
                  className="location-info__station-link"
                  href={website_url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {translate("info_window.website")}
                </a>
              ),
            },
            this.openingHoursSection(),
            this.fuelSection(),
            this.amenitiesSection(),
          ].filter((v) => Boolean(v))}
        />
      </Pane>
    )
  }
}

export default InfoWindowView
